// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__Ry01C","content":"style_content__3GGWu"};